var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmail = function SvgEmail(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.13645V0.827942C0 0.62856 0.0790176 0.437344 0.21967 0.29636C0.360322 0.155376 0.551088 0.0761719 0.75 0.0761719L11.25 0.0761719C11.4489 0.0761719 11.6397 0.155376 11.7803 0.29636C11.921 0.437344 12 0.62856 12 0.827942V1.13645L6 4.8953L0 1.13645ZM6.19875 5.65741C6.13914 5.6947 6.07027 5.71447 6 5.71447C5.92973 5.71447 5.86086 5.6947 5.80125 5.65741L0 2.02297V8.34564C0 8.54502 0.0790176 8.73624 0.21967 8.87722C0.360322 9.01821 0.551088 9.09741 0.75 9.09741H11.25C11.4489 9.09741 11.6397 9.01821 11.7803 8.87722C11.921 8.73624 12 8.54502 12 8.34564V2.02297L6.19875 5.65741Z",
    fill: "#2E3744"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "email.dd51532decec6645af6639dc8c8f27cc.svg";